import React, { useEffect } from 'react';
import Header from './components/Header';
import MobileNav from './components/MobileNav';
import SideBar from './components/SideBar';
import LoaderSM from '../../components/LoaderSM';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import UserGif from '../../assets/gif/user.gif'
import ArtisanGif from '../../assets/gif/maker.gif'
import ProductGif from '../../assets/gif/product.gif'
import BagGif from '../../assets/gif/bag.gif'
import PaidGif from '../../assets/gif/paid.gif'
import ReportGif from '../../assets/gif/report.gif'
import DeliveredGif from '../../assets/gif/delivered.gif'
import ArtisanPGif from '../../assets/gif/artisan_product.gif'
import AdminGif from '../../assets/gif/admin.gif'

import { 
    getUserCounts, 
    getArtisanCounts, 
    getAdminCounts, 
    getProductCounts, 
    getArtisanProductCounts,
    getOrderCounts,
    getOrderPaidCounts,
    getOrderDeliveredCounts,
    getUserReportCounts
} from '../../redux/actions/CountAction';



const AdminDashboard = ({ 
    getUserCounts, userCount, 
    getArtisanCounts, artisanCount,    
    getAdminCounts, adminCount,
    getProductCounts, productCount,
    getArtisanProductCounts, artisanProductCount,
    getOrderCounts, orderCount,
    getOrderPaidCounts, orderPaidCount,
    getOrderDeliveredCounts, orderDeliveredCount,
    getUserReportCounts, userReportCount,
}) => {


    const { loading:userLoading, users } = userCount;
    const { loading:artisanLoading, artisans } = artisanCount;
    const { loading:adminLoading, admins } = adminCount;
    const { loading:productLoading, products } = productCount;
    const { loading:artisanProductLoading, artisan_products } = artisanProductCount;
    const { loading:orderLoading, orders } = orderCount;
    const { loading:orderPaidLoading, order_paid } = orderPaidCount;
    const { loading: orderDeliveredLoading, order_delivered } = orderDeliveredCount;
    const {loading:reportLoading, user_report } = userReportCount;



    useEffect(() => {
        getUserCounts()
        getArtisanCounts()
        getAdminCounts()
        getProductCounts()
        getArtisanProductCounts()
        getOrderCounts()
        getOrderPaidCounts()
        getOrderDeliveredCounts()
        getUserReportCounts()
    }, [
        getUserCounts, 
        getArtisanCounts, 
        getAdminCounts, 
        getProductCounts, 
        getArtisanProductCounts, 
        getOrderCounts, 
        getOrderPaidCounts,
        getOrderDeliveredCounts,
        getUserReportCounts])

    return (
        <div className='bg-gray-50 min-h-screen'>
            <SideBar />
            <MobileNav />
            <Header />
            <div className='md:ml-72 px-4'>
                <div className='my-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 '>
                    <Link to='/admin/userList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(90deg, hsla(16, 100%, 76%, 1) 0%, hsla(49, 100%, 81%, 1) 100%)'  }}>
                            <img src={UserGif} alt='user' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Users</p>
                            { userLoading ? <LoaderSM /> :  <div className='mt-1 text-md font-medium'>+{ users && users.len}</div>  }
                        </div>
                    </Link>
                    <Link to='/admin/makerList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(90deg, hsla(18, 76%, 85%, 1) 0%, hsla(203, 69%, 84%, 1) 100%)'  }}>
                            <img src={ArtisanGif} alt='user' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Artisans</p>
                            { artisanLoading ? <LoaderSM /> :  <div className='mt-1 text-md font-medium'>+{ artisans && artisans.len}</div>  }
                        </div>
                    </Link>

                    <Link to='/admin/adminList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%)'  }}>
                            <img src={AdminGif} alt='user' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Admin</p>
                            { adminLoading ? <LoaderSM /> :  <div className='mt-1 text-md font-medium'>+{ admins && admins.len}</div>  }
                        </div>
                    </Link>


                    <Link to='/admin/productList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(90deg, hsla(186, 33%, 94%, 1) 0%, hsla(216, 41%, 79%, 1) 100%)' }}>
                            <img src={ProductGif} alt='product' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Products</p>
                            {productLoading ? <LoaderSM /> : <div className='mt-1 text-md font-medium'>+{products && products.len}</div>}
                        </div>
                    </Link>


                    <Link to='/admin/artisan/product' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(to top, #d299c2 0%, #fef9d7 100%)' }}>
                            <img src={ArtisanPGif} alt='user' className='w-12 h-12' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Artisan Products</p>
                            {artisanProductLoading ? <LoaderSM /> : <div className='mt-1 text-md font-medium'>+{artisan_products && artisan_products.len}</div>  }
                        </div>
                    </Link>
                    
                   

                    <Link to='/admin/orderList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(90deg, hsla(11, 82%, 87%, 1) 0%, hsla(299, 85%, 90%, 1) 100%)'  }}>
                            <img src={BagGif} alt='user' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Orders</p>
                            {orderLoading ? <LoaderSM /> : <div className='mt-1 text-md font-medium'>+{orders && orders.len}</div>  }
                        </div>
                    </Link>


                    <Link to='/admin/orderList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(to top, #feada6 0%, #f5efef 100%)'  }}>
                            <img src={PaidGif} alt='user' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Order Paid</p>
                            {orderPaidLoading ? <LoaderSM /> : <div className='mt-1 text-md font-medium'>+{order_paid && order_paid.len}</div>  }
                        </div>
                    </Link>

                    <Link to='/admin/orderList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(to top, #c1dfc4 0%, #deecdd 100%)'  }}>
                            <img src={DeliveredGif} alt='user' className='w-14 h-12 object-contain' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Order Delivered</p>
                            {orderDeliveredLoading ? <LoaderSM /> : <div className='mt-1 text-md font-medium'>+{order_delivered && order_delivered.len}</div>  }
                        </div>
                    </Link>



                    <Link to='/admin/report' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: ' linear-gradient(90deg, hsla(40, 63%, 85%, 1) 0%, hsla(22, 94%, 79%, 1) 100%)'  }}>
                            <img src={ReportGif} alt='user' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Reports</p>
                            {reportLoading ? <LoaderSM /> : <div className='mt-1 text-md font-medium'>+{user_report && user_report.len}</div>}
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    userCount: state.userCount,
    artisanCount: state.artisanCount,
    adminCount: state.adminCount,
    productCount: state.productCount,
    artisanProductCount: state.artisanProductCount,
    orderCount: state.orderCount,
    orderPaidCount: state.orderPaidCount,
    orderDeliveredCount: state.orderDeliveredCount,
    userReportCount: state.userReportCount
})


export default connect(mapStateToProps, { 
    getUserCounts, 
    getArtisanCounts,
    getAdminCounts, 
    getProductCounts,
    getArtisanProductCounts,
    getOrderCounts,
    getOrderPaidCounts,
    getOrderDeliveredCounts,
    getUserReportCounts,
})(AdminDashboard);